/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import { BrowseSwitcherLink } from '@app/router';
import { useIsNonInteractiveViewer } from '@app/ui';
import { useTranslation } from 'react-i18next';
import useUrlPrefix from '@app/hooks/useUrlPrefix';
import { trackEvent, EVENTS } from '@app/segment';
import useVertical from '@app/catalog/hooks/useVertical';

import BrowseDropdown from './components/BrowseDropdown';

const Browse = () => {
  const isNonInteractiveViewer = useIsNonInteractiveViewer();
  const { t } = useTranslation();
  const urlPrefix = useUrlPrefix();
  const [currentVertical] = useVertical(true);
  const [browseNavRendered, setBrowseNavRendered] = useState(
    isNonInteractiveViewer,
  );

  return (
    <li
      className="browse-dropdown"
      key="price guide"
      onMouseEnter={() => setBrowseNavRendered(true)}
      data-testid="navbar-menu-browse"
    >
      <BrowseSwitcherLink
        to={`${urlPrefix}${currentVertical}`}
        onClick={() => {
          trackEvent(EVENTS.NAVIGATION_ITEM_CLICKED, {
            label: t('Browse'),
          });
        }}
      >
        {t('Browse')}
      </BrowseSwitcherLink>
      {browseNavRendered && <BrowseDropdown />}
    </li>
  );
};

export default Browse;
